<template>
<div class="form-body">
  <div class="row">
    <div class="form-holder">
      <div class="form-content">
        <div class="form-items" style="margin-top: 2%;">
          <div>
            <div class="form-row newDesign">
                <span class="logo" style="width: 100%;" v-html="logos"></span>
                <span class="logo" style="width: 100%;" v-html="REGISTERATION_SUCCESS_ICON"></span>
                <p class="lead success-text-align" style="font-size:20px;color:#141414;line-height: 23px;text-align: center;"><strong>Link to reset password is sent to your registered email!</strong></p>
                <!-- <p class="lead success-sub-text-align" style="line-height: 23px;text-align: center;">You can now sign in with your new password</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { REGISTERATION_SUCCESS, logo } from '../../shared/svg'
import router from '../../router/index'
export default {
  name: 'registerationComplete',
  data () {
    return {
      REGISTERATION_SUCCESS_ICON: REGISTERATION_SUCCESS,
      logos: logo
    }
  },
  created () {
    const data = JSON.parse(localStorage.getItem('setPassword'))
    if (data === false || data === undefined) {
      router.push({ name: 'Login' })
    }
  },
  methods: {
    setPasswordStatus () {
      localStorage.setItem('setPassword', JSON.stringify(true))
    }
  }
}
</script>

<style scoped>
.form-holder {
  margin-left: 0px;
  width: 100%;
}
.success-text-align {
  width: 100%;
  font-weight: 400;
}
.success-sub-text-align {
  width: 100%;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-content {
    width: 100%;
}
.form-content p {
  line-height: 5px;
}
</style>
